import { render, staticRenderFns } from "./charges.vue?vue&type=template&id=76deb6d3"
import script from "./charges.vue?vue&type=script&lang=js"
export * from "./charges.vue?vue&type=script&lang=js"
import style0 from "./charges.vue?vue&type=style&index=0&id=76deb6d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports